// extracted by mini-css-extract-plugin
export default {"blackColor":"#000000","modal":"modal_modal__QIqyg","visible":"modal_visible__NnOU0","backdrop":"modal_backdrop__oAS5e"};